<div class="container-fluid notification-board">
  @if (!notificationGroups.length) {
    <p class="title">{{ 'NOTIFICATION_BOARD.NO_NOTIFICATIONS' | translate }}</p>
  }
  @if (notificationGroups.length) {
    <div class="notification-board__filter row mb-3">
      @for (group of notificationGroups; track group) {
        <div
          class="notification-board__filter-chip mr-2 mb-2"
          [class.notification-board__filter-chip--selected]="selectedNotificationGroup == group.kind"
          (click)="filterNotifications(group.kind)"
          >
          {{ group.header | translate }}
          <span class="notification-board__chip-count">{{ group.notifications.length }}</span>
        </div>
      }
      <div
        class="notification-board__filter-chip mb-2"
        [class.notification-board__filter-chip--selected]="!selectedNotificationGroup"
        (click)="filterNotifications(null)"
        >
        {{ 'ALL_TEXT' | translate }}
        <span class="notification-board__chip-count">{{ allNotificationsCount }}</span>
      </div>
    </div>
  }
  @if (notificationGroups.length) {
    <div class="row notification-board__scroll">
      @for (group of notificationGroupsFiltered; track group) {
        <div class="notification-board__group mb-3">
          <span class="title notification-board__group-title">{{ group.header | translate }}</span>
          <div class="notification-board__group-content">
            @for (item of group.notifications; track item) {
              <div class="notification">
                <a class="notification-board__card" [routerLink]="item.href" [queryParams]="item.params">
                  <div class="notification-board__title">
                    <span class="title">{{ item.header | translate }}</span>
                  </div>
                  <div class="mt-3 notification-board__count">
                    <span>{{ item.count }}</span>
                  </div>
                </a>
              </div>
            }
          </div>
        </div>
      }
    </div>
  }
</div>
